module.exports = __webpack_public_path__ + "ba6d464c9973fdb8794091f0f76283b8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-16.png
// module id = 1732
// module chunks = 0